import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import moment from 'moment';
import { connect } from 'react-redux';
import compose from 'recompose/compose';
import { propShape } from '../../helpers/custom-prop-types';
import Layout from '../Layout';
const Maintenance = ({ maintenance }) => {
    const validFrom = maintenance &&
        maintenance.validFrom &&
        moment.unix(maintenance.validFrom).format('YYYY/MM/DD HH:mm');
    const validUntil = maintenance &&
        maintenance.validUntil &&
        moment.unix(maintenance.validUntil).format('HH:mm');
    return (_jsx(Layout, Object.assign({ mainClassName: 'l-main', type: 'maintenance' }, { children: _jsx("div", Object.assign({ className: 'l-container l-contents l-contents-spacer' }, { children: _jsxs("div", Object.assign({ className: 'l-container-12 align-center' }, { children: [_jsx("h2", Object.assign({ className: 'maintenance-title' }, { children: "\u30E1\u30F3\u30C6\u30CA\u30F3\u30B9\u306E\u304A\u77E5\u3089\u305B" })), _jsxs("div", Object.assign({ className: 'maintenance-box' }, { children: [_jsxs("p", Object.assign({ className: 'honbun' }, { children: ["\u305F\u3060\u3044\u307E\u30E1\u30F3\u30C6\u30CA\u30F3\u30B9\u4E2D\u3067\u3059\u3002", _jsx("br", {}), "\u30E1\u30F3\u30C6\u30CA\u30F3\u30B9\u7D42\u4E86\u307E\u3067\u3057\u3070\u3089\u304F\u304A\u5F85\u3061\u4E0B\u3055\u3044\u3002"] })), validFrom && validUntil && (_jsxs(_Fragment, { children: [_jsx("h4", { children: "\u30E1\u30F3\u30C6\u30CA\u30F3\u30B9\u671F\u9593" }), _jsx("em", { children: `${validFrom} - ${validUntil}` }), _jsx("small", { children: "\u203B\u4F5C\u696D\u6642\u9593\u306F\u524D\u5F8C\u3059\u308B\u53EF\u80FD\u6027\u304C\u3042\u308A\u307E\u3059" })] }))] }))] })) })) })));
};
Maintenance.propTypes = {
    maintenance: propShape(),
};
Maintenance.defaultProps = {
    maintenance: null,
};
const mapStateToProps = ({ maintenance }) => ({
    maintenance: maintenance.data,
});
const enhance = compose(connect(mapStateToProps));
export default enhance(Maintenance);
